import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import { EditCellContext } from 'src/contexts/EditCellContext';

const TransactionLog = (props: GridCellProps) => {
  const { dataItem } = props;
  const [cellClick] = useContext(EditCellContext);
  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      cellClick?.(dataItem);
    },
    [cellClick, dataItem]
  );
  return (
    <GridCellBase {...props} disableToolTip className="!text-center !p-0 relative">
      <Button
        color="secondary"
        onClick={handleClick}
        size="sm"
        className="absolute top-0 left-[50%] -translate-x-[50%]"
      >
        View
      </Button>
    </GridCellBase>
  );
};

export default TransactionLog;
